export default __webpack_public_path__ + "static/media/oos.506411cb.png";